import { useState } from 'react';
import { isValidDomain } from '../../validation/PropertyValidations';
import UIEditableControls from 'UIComponents/editable/UIEditableControls';
import DomainInput from './DomainInput';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function NewValue({
  domains,
  onSave,
  onCancel,
  showAutoSaveText
}) {
  const [value, setValue] = useState('');
  const duplicateValue = domains.includes(value);
  const isSaveDisabled = !value || !isValidDomain(value) || duplicateValue;
  const confirmLabel = showAutoSaveText ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputMultipleDomain.save"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputMultipleDomain.apply"
  });
  return /*#__PURE__*/_jsxs(UIGrid, {
    children: [/*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 8
      },
      children: /*#__PURE__*/_jsx(UIEditableControls, {
        className: "m-bottom-1",
        onCancel: onCancel,
        onSave: () => onSave(value),
        saveDisabled: isSaveDisabled,
        use: "flush",
        saveLabel: confirmLabel,
        children: /*#__PURE__*/_jsx(DomainInput, {
          autoFocus: true,
          className: "p-x-2",
          onChange: e => setValue(e.target.value),
          value: value
        })
      })
    }), /*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 4
      }
    })]
  });
}
export default NewValue;